import { BareButton } from '@calendly/ui/components/bare-button';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { primaryColorL1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import hubspotIconSrc from 'components/integrations/elements/provider_logo/logos/hubspot.svg';
import { RecordingRulesSwitch } from './recording_rules_switch';
const integrationCardCss = "iedjoru";
const integrationCardMobileCss = "i1h5szkx";
const IntegrationCardContainer = ({
  isPhone,
  ...props
}) => <div {...props} className={classNames(integrationCardCss, {
  [integrationCardMobileCss]: isPhone
}, props.className)} />;
const logoWrapperCss = "l1mgehnm";
const LogoWrapper = props => <div {...props} className={classNames(logoWrapperCss, props.className)} />;
const logoCss = "lj3gvad";
const integrationNameCss = "i9xnoom";
const IntegrationName = props => <div {...props} className={classNames(integrationNameCss, props.className)} />;
const switchContainerCss = "sgq7gkh";
const SwitchContainer = props => <div {...props} className={classNames(switchContainerCss, props.className)} />;
const pushRecapsTextCss = "p1jq6s89";
const pushRecapsTextMobileCss = "p27qff8";
const headerRowCss = "h1c0vxeq";
const HeaderRow = props => <div {...props} className={classNames(headerRowCss, props.className)} />;
const controlsRowCss = "c1crqj8b";
const ControlsRow = props => <div {...props} className={classNames(controlsRowCss, props.className)} />;
const linkWrapperCss = "l176o19l";
const LinkWrapper = props => <BareButton {...props} className={classNames(linkWrapperCss, props.className)} />;
const getLogo = name => {
  if (name === 'hubspot') {
    return <img src={hubspotIconSrc} alt="Hubspot" className={logoCss} />;
  }

  // Use BrandLogo for other integrations
  let brandName = name;
  if (name === 'salesforce') {
    brandName = 'salesforce';
  } else if (name === 'zapier') {
    brandName = 'zapier';
  }
  return <BrandLogo name={brandName} className={logoCss} />;
};
const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1);
export const IntegrationsCard = ({
  integration,
  onToggle,
  setIsDirty
}) => {
  const {
    name,
    enabled,
    connected
  } = integration;
  const displayName = capitalizeFirst(name);
  const settingsLink = `/integrations/${name}`;
  const isPhone = useDeviceType('isPhone');
  if (isPhone) {
    return <IntegrationCardContainer isPhone={isPhone}>
        <HeaderRow>
          <LogoWrapper>
            {getLogo(name)}
          </LogoWrapper>
          <IntegrationName>
            <BodyText size="medium" weight="bold">
              {displayName}
            </BodyText>
          </IntegrationName>
        </HeaderRow>
        {connected && <ControlsRow>
            <SwitchContainer>
              <RecordingRulesSwitch value={enabled} onChange={onToggle} setIsDirty={setIsDirty} />
            </SwitchContainer>
            <BodyText size="medium" className={classNames(pushRecapsTextCss, pushRecapsTextMobileCss)}>
              Push recaps
            </BodyText>
            <LinkWrapper as="a" href={settingsLink} target="_blank" rel="noopener noreferrer">
              <BodyText size="medium" color="primary">
                Settings
              </BodyText>
              <ArrowExpandIcon size="standard" color={primaryColorL1} />
            </LinkWrapper>
          </ControlsRow>}
        {!connected && <ControlsRow>
            <LinkWrapper as="a" href={settingsLink} target="_blank" rel="noopener noreferrer">
              <BodyText size="medium" color="primary">
                Connect
                {' '}
                {displayName}
              </BodyText>
              <ArrowExpandIcon size="standard" color={primaryColorL1} />
            </LinkWrapper>
          </ControlsRow>}
      </IntegrationCardContainer>;
  }

  // Desktop layout (original)
  return <IntegrationCardContainer>
      <LogoWrapper>
        {getLogo(name)}
      </LogoWrapper>
      <IntegrationName>
        <BodyText size="medium" weight="bold">
          {displayName}
        </BodyText>
      </IntegrationName>
      {connected && <>
          <SwitchContainer>
            <RecordingRulesSwitch value={enabled} onChange={onToggle} setIsDirty={setIsDirty} />
          </SwitchContainer>
          <BodyText size="medium" className={pushRecapsTextCss}>
            Push recaps
          </BodyText>
        </>}
      <LinkWrapper as="a" href={settingsLink} target="_blank" rel="noopener noreferrer">
        <BodyText size="medium" color="primary">
          {connected ? 'Settings' : `Connect ${displayName}`}
        </BodyText>
        <ArrowExpandIcon size="standard" color={primaryColorL1} />
      </LinkWrapper>
    </IntegrationCardContainer>;
};

require("./integrations_card.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./integrations_card.js");